export class PrinterSetup {
    id: number;
    hotel_id: number;
    table_name: string;
    table_record_id: number;
    report_name: string;
    printer_id: number;
    printer: Printer;

    constructor() {
        this.id = 0;
        this.hotel_id = 0;
        this.table_name = '';
        this.table_record_id = 0;
        this.report_name = '';
        this.printer_id = 0;
    }
}

export class Printer {
    id: number;
    hotel_id: number;
    host_name: string;
    printer_name: string;
    printer_alias: string;
    description: string;

    constructor() {
        this.id = 0;
        this.hotel_id = 0;
        this.host_name = '';
        this.printer_name = '';
        this.printer_alias = '';
        this.description = '';
    }

}
